import { app } from "@/app";
import { configureRouter as configureAdminRouter } from "@/apps/admin/router";
import { Routes as AdminRoutes } from "@/apps/admin/router/routes";
import { configureRouter as configureNormalRouter } from "@/apps/normal/router";
import { configureHttp } from "@/config/http";
import { i18n } from '@/i18n';
import router from "@/router";
import {
  useLocaleStore,
  useUserStore
} from "@/store";
import { MessageAdapter } from "@/util/message";
import { LocalStorageAdapter } from "@/util/web-storage";
import { bannerService } from '@package/shared/admin/service/banner.service';
import { customService } from '@package/shared/admin/service/custom.service';
import { logoService } from '@package/shared/admin/service/logo.service';
import { navService } from '@package/shared/admin/service/nav.service';
import { newsTypeService } from '@package/shared/admin/service/news-type.service';
import { productService } from '@package/shared/admin/service/product.service';
import { message } from "@package/shared/util/message";
import { storage } from "@package/shared/util/storage";
import { ElLoading } from "element-plus";
import 'element-plus/es/components/loading/style/css';
import "element-plus/es/components/message-box/style/css";
import "element-plus/es/components/message/style/css";
import { createPinia } from "pinia";

const srvLoading = ElLoading.service();

{
  // global (app.config.globalProperties)
}

{
  // elem
  const components = [];
  for (const component of components) {
    app.use(component);
  }
}

app.use(i18n).use(createPinia()).use(router);

{
  // setup

  const storageAdapter = new LocalStorageAdapter();

  {
    // default
    storage.setAdapter(storageAdapter);
    message.setAdapter(new MessageAdapter());
  }

  {
    // global
    configureHttp();
  }

  {
    // normal
    configureNormalRouter(router);
  }

  {
    // admin
    configureAdminRouter(router);
  }

  {
    // 全局状态
    let locale = storage.get<'zh-CN' | 'en'>('locale')!;
    locale = ['zh-CN', 'en'].includes(locale) ? locale : 'zh-CN';
    const localeStore = useLocaleStore();
    localeStore.$patch({ value: locale });
    localeStore.$subscribe((_, { value }) => {
      if (value) storage.set("locale", value);
      else storage.del("locale");
    });

    const user = storage.get<{ username, token; }>('user') || {};
    const userStore = useUserStore();
    userStore.$patch(user);
    userStore.$subscribe((_, user) => {
      if (user.token) storage.set("user", user);
      else {
        storage.del("user");
        router.replace(AdminRoutes.login);
      }
    });
  }
}

{
  // 预加载
  await Promise.allSettled([
    logoService.requestDataSource(),
    navService.requestDataSource(),
    bannerService.requestDataSource(),
    customService.requestDataSource(),
    productService.requestDataSource(),
    newsTypeService.requestDataSource(),
  ]);
}

srvLoading.close();

app.mount("#app");
